const WEEKS_COUNT = 52;
const MINS_TOTAL_CONSTANT = 9;
const MINS_PARKING_CONSTANT = 4;
const MINS_REPORTING_CONSTANT = 4;
const MINS_ADMIN_CONSTANT = 1;
const MINS_COUNT = 480;

export const calculateResultValues = (
  parkingsCount: number,
  employeesCount: number,
) => {
  return {
    total: Math.round(
      (employeesCount * parkingsCount * WEEKS_COUNT * MINS_TOTAL_CONSTANT) /
        MINS_COUNT,
    ),
    parking: Math.round(
      (employeesCount * parkingsCount * WEEKS_COUNT * MINS_PARKING_CONSTANT) /
        MINS_COUNT,
    ),
    reporting: Math.round(
      (employeesCount * parkingsCount * WEEKS_COUNT * MINS_REPORTING_CONSTANT) /
        MINS_COUNT,
    ),
    administration: Math.round(
      (employeesCount * parkingsCount * WEEKS_COUNT * MINS_ADMIN_CONSTANT) /
        MINS_COUNT,
    ),
  };
};